import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useFormik } from "formik";
import TextField from '@mui/material/TextField';
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LoadingButton from '@mui/lab/LoadingButton';
import * as yup from "yup";
import { Link } from 'react-router-dom';

const Login = (props) => {
    const {
        login,
        is_loading,
        show_password,
        handleClickShowPassword,
        company_details
    } = props;
    const validationSchema = yup.object().shape({
        username: yup.string().trim().required('Username is required'),
        password: yup.string().trim().required('Password is required'),
    });

    const handlePassword = () => {
        handleClickShowPassword(!show_password);
    }

    const onSubmit = async (values) => {
        values.company_domain = window.location.hostname;
        login(values);
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            username: "",
            password: "",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSubmit(values);
        },
    })
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                padding: { xs: '16px', sm: '24px', md: '30px' },
                backgroundColor: '#fafafa'
            }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                maxWidth: '1200px'
            }}>
                <Paper
                    variant="elevation"
                    elevation={1}
                    square={false}
                    sx={{
                        minHeight: { md: '500px', xs: 'auto' },
                        height: 'auto',
                        maxWidth: { md: '900px', sm: '600px', xs: '100%' },
                        width: "100%",
                        boxShadow: 'rgba(0, 0, 0, 0.04) 0px 10px 10px 4px',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: { md: 'row', xs: 'column' },
                        position: 'relative'

                    }}>
                    <Box sx={{
                        width: { md: '50%', xs: '100%' },
                        height: { md: '100%', xs: '8rem' },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <img src='/images/login.png' alt='login.png' style={{ width: "100%", height: '100%', objectFit: 'cover' }} />
                    </Box>
                    <Box sx={{
                        width: { md: '50%', xs: '100%' },
                        padding: { md: '40px', xs: '20px' },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Box sx={{
                            width: "100%"
                        }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                mt: 2,
                                '& .companyLogo': {
                                    width: '12rem',
                                    objectFit: 'contain'
                                }
                            }}>
                                <a href='/'><img className='companyLogo' src={company_details?.company_logo} alt='logo.png' /></a>
                            </Box>
                            <Typography
                                align='center'
                                variant='h5'
                                sx={{
                                    fontWeight: 600,
                                    mt: 3
                                }}
                            >Welcome to {company_details?.name}
                            </Typography>
                            <Box mt={2} sx={{
                                width: '100%'
                            }}>
                                <Typography
                                    variant='h6'
                                    sx={{
                                        fontWeight: 600
                                    }}
                                >Login
                                </Typography>
                                <form onSubmit={formik.handleSubmit} autoComplete="off">
                                    <Box sx={{
                                        '& .MuiTextField-root': { my: 1.5 },
                                        display: 'flex',
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column"
                                    }}>
                                        <TextField
                                            label="Username"
                                            variant="outlined"
                                            size='small'
                                            fullWidth
                                            name="username"
                                            value={formik.values.username}
                                            onChange={formik.handleChange("username")}
                                            onBlur={formik.handleBlur("username")}
                                            error={
                                                formik.touched.username && Boolean(formik.errors.username)
                                            }
                                            helperText={formik.touched.username && formik.errors.username}
                                        />
                                        <TextField
                                            id="password"
                                            label="Password"
                                            variant="outlined"
                                            type={show_password ? 'text' : 'password'}
                                            size='small'
                                            fullWidth
                                            slotProps={{
                                                input: {
                                                    endAdornment: (
                                                        <InputAdornment
                                                            position="end"
                                                            onClick={handlePassword}
                                                            sx={{ cursor: "pointer" }}
                                                        >
                                                            {show_password ? <VisibilityOff /> : <Visibility />}
                                                        </InputAdornment>
                                                    )
                                                }
                                            }}
                                            name="password"
                                            value={formik.values.password}
                                            onChange={formik.handleChange("password")}
                                            onBlur={formik.handleBlur("password")}
                                            error={
                                                formik.touched.password && Boolean(formik.errors.password)
                                            }
                                            helperText={formik.touched.password && formik.errors.password}
                                        />
                                        <Box my={1} display='flex' justifyContent='start' width='100%'>
                                            <Link to="/forgot-password/request" style={{ textDecoration: 'none', color: '#438FCD', fontSize: '14px' }}>Forget Your Password?</Link>
                                        </Box>
                                        <LoadingButton
                                            sx={{
                                                my: 1
                                            }}
                                            size="medium"
                                            type='submit'
                                            loading={is_loading}
                                            variant="contained"
                                            disableElevation
                                            fullWidth
                                        >
                                            <span>Log In</span>
                                        </LoadingButton>
                                    </Box>
                                </form>
                                <Box my={1} display='flex' justifyContent='center' width='100%'>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </Box>

    )
}

export default Login
